<template>
  <div>
    <LeftSideBar
      :newVisibleLeft="newVisibleLeft"
      :hoverVariable="hoverVariable"
      :hoverVariableSubItem="hoverVariableSubItem"
      :newSelectedAnalysis="newSelectedAnalysis"
      :newSelectedAnalysisParent="newSelectedAnalysisParent"
      :itemsInformation="itemsInformationSideBar"
      @onHoverLeftSidebar="onHoverLeftSidebar"
      @onHoverLeftSidebarSubItem="onHoverLeftSidebarSubItem"
      @onLeftSidebarAnalysis="onLeftSidebarAnalysis"
      @eventOnUserClick="onUserClickLeftSidebarShow"
      @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
      @eventOnSidebarItemsChange="onSidebarItemsChange"
    />
  </div>
</template>

<script>
import LeftSideBar from "../sideBars/LeftSideBar.vue";

export default {
  name: "LeftSidebarAnalyticsCom",
  components: {
    LeftSideBar
  },
  props: {
    selectedAnalysis: { required: true, default: "" },
    selectedAnalysisParent: { required: true, default: "" },
    visibleLeft: { required: true, type: Boolean, default: false },
    selectedChildName: { required: false, type: Object, default: () => ({}) }
  },
  data() {
    return {
      hoverVariable: "",
      hoverVariableSubItem: "",
      newSelectedAnalysis: "valuation",
      newSelectedAnalysisParent: "",
      newVisibleLeft: false,
      itemsInformationSideBar: [
        {
          text: "",
          nameEvent: "",
          bdr: false,
          itemHeader: false,
          classNameIcon: "",
          bdrTransition: false
        }
      ]
    };
  },
  created() {
    this.setItemsSideBar();
  },
  mounted() {
    this.newSelectedAnalysis = this.selectedAnalysis;
    this.newSelectedAnalysisParent = this.selectedAnalysisParent;
    this.newVisibleLeft = this.visibleLeft;
  },
  watch: {
    selectedAnalysis(val) {
      this.newSelectedAnalysis = val;
    },
    selectedAnalysisParent(val) {
      this.newSelectedAnalysisParent = val;
    },
    visibleLeft(val) {
      this.newVisibleLeft = val;
    },
    selectedChildName(val) {
      if (!val) return;

      this.newSelectedAnalysis = val.selectedAnalysis;
      this.newSelectedAnalysisParent = val.selectedAnalysisParent;
    }
  },
  methods: {
    onHoverLeftSidebar(val) {
      this.hoverVariable = val;
    },
    onHoverLeftSidebarSubItem(val) {
      this.hoverVariableSubItem = val;
    },
    onUserClickLeftSidebarShow() {
      this.$emit("eventOnUserClickLeftSidebarShow", !this.visibleLeft);
    },
    onLeftSidebarAnalysisScenarios(event) {
      this.hoverVariable = "";
      this.$emit("onLeftSidebarAnalysisScenarios", event);
    },
    onLeftSidebarAnalysis({ val, parent }) {
      this.$emit("eventOnLeftSidebarAnalysis", { val, parent });
    },
    onSidebarItemsChange(items) {
      Object.assign(this.itemsInformationSideBar, items);
    },
    setItemsSideBar() {
      Object.assign(this.itemsInformationSideBar, [
        {
          text: "Valuation",
          nameEvent: "valuation",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-check-square",
          bdrTransition: false
        },
        {
          text: "Management",
          nameEvent: "contractManagement",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-chart-bar",
          bdrTransition: true,
          children: [
            {
              text: "Strategies",
              nameEvent: "strategies",
              nameEventParent: "contractManagement"
            },
            {
              text: "Contracts",
              nameEvent: "contracts",
              nameEventParent: "contractManagement"
            },
            {
              text: "Date",
              nameEvent: "date_2",
              nameEventParent: "contractManagement"
            },
            {
              text: "Clients",
              nameEvent: "clients",
              nameEventParent: "contractManagement"
            },
            {
              text: "Suppliers",
              nameEvent: "suppliers",
              nameEventParent: "contractManagement"
            }
          ]
        },
        {
          text: "Analysis",
          nameEvent: "scenarios",
          bdr: false,
          itemHeader: false,
          itemParent: true,
          classNameIcon: "pi pi-align-center",
          bdrTransition: true,
          children: [
            {
              text: "Portfolio",
              nameEvent: "scenario",
              nameEventParent: "scenarios"
            },
            {
              text: "Strategies",
              nameEvent: "strategies",
              nameEventParent: "scenarios"
            },
            {
              text: "Derivatives",
              nameEvent: "derivatives",
              nameEventParent: "scenarios"
            },
            {
              text: "Suppliers",
              nameEvent: "providers",
              nameEventParent: "scenarios"
            },
            {
              text: "Clients",
              nameEvent: "clients",
              nameEventParent: "scenarios"
            },
            {
              text: "Counterparty",
              nameEvent: "counterparty",
              nameEventParent: "scenarios"
            }
          ]
        }
      ]);
    }
  }
};
</script>
